// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.disabled[data-v-25d19df8] {\n  cursor: not-allowed;\n}\n", ""]);
// Exports
module.exports = exports;
